// extracted by mini-css-extract-plugin
module.exports = {"layout":"section-divider_layout__R7J9n","heading":"section-divider_heading__oCAUO"};